import { render, staticRenderFns } from "./superBDetails.vue?vue&type=template&id=af0ae336&"
import script from "./superBDetails.vue?vue&type=script&lang=js&"
export * from "./superBDetails.vue?vue&type=script&lang=js&"
import style0 from "./superBDetails.vue?vue&type=style&index=0&id=af0ae336&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports